<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    v-if="profile != null"
>
    <div
        style="display: flex"
    >
        <div
            style="flex-grow: 1"
        >
            <v-text-field
                label="Bulk Message Name"
                :value="profile.bulk_message.label"
                readonly
                disabled
            />
        </div>
        <div
            style="flex-grow: 0; margin-top: 15px; margin-left: 15px;"
        >
            <v-btn
                v-on:click="onClickBack"
            >
                Back
            </v-btn>
        </div>
    </div>

    <div
        style="margin-bottom: 35px;"
    >
        <b>Message Patterns</b>
        <ul class="text-body-1">
            <li
                v-for="(pattern, index) in profile.bulk_message.message_patterns"
                :key="index"
            >
                {{ pattern }}
            </li>
        </ul>
    </div>    

    <v-row>
        <v-col>
            <v-text-field
                label="First Name"
                :value="profile.inference_summary.first_name"
                readonly
                disabled
            />
        </v-col>
        <v-col>
            <v-text-field
                label="Last Name"
                :value="profile.inference_summary.last_name"
                readonly
                disabled
            />
        </v-col>
        <v-col>
            <v-text-field
                label="Phone Number"
                :value="$rc.pretty(profile.inference_summary.recipient_endpoint, 'endpoint_no_parens')"
                readonly
                disabled
            />
        </v-col>
    </v-row>
    <v-row
        style="margin-top: -25px; margin-bottom: 15px;"
    >
        <v-col>
            <v-text-field
                label="Sentiment Forecast"
                :value="profile.inference_summary.output_forecast"
                readonly
                disabled
            />
        </v-col>

        <v-col>
            <v-text-field
                label="Last Update Time"
                :value="$rc.pretty(profile.inference_summary.time_last_modified,'date_and_time')"
                readonly
                disabled
            />
        </v-col>

    </v-row>

    

    <m-model-r1-layer-inference
        v-for="(layer, index) in layers"
        :key="'inference_'+index"
        :layer="layer"
        style="margin-bottom: 15px"
        readonly
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            layers: [
                'days-since-last-non-club-purchase',
                'days-since-last-promotional-message',
                'bulk-message-order-attribution-percentile',
                'is-active-club-member',
                'background'
            ],

            profile: null,
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        doUpdate() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/model/r1/inference/summary/:bulk_message_recipient_id',
            
                'params' : {
                        'bulk_message_recipient_id': this.$route.params.bulk_message_recipient_id,
                    },
            
                'on_success': (data) => {
                        this.profile = data;
                    },
            
                'on_error': 'Unable to get inference results',
            });
        },

        onClickBack()
        {
            this.$router.push({
                'name': 'bulk-message-sentiment-forecast',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'bulk_message_id': this.$route.params.bulk_message_id,
                }
            });
        },
    },

    computed: {
        title() {

            if ( this.profile == null )
                return 'Sentiment Forecast Details';

            let score = this.profile.inference_summary.output_forecast ?? 'no score';

            return 'Sentiment Forecast Details: '+this.profile.label+' ('+score+')';
        }
    },
    
}
</script>

<style lang="scss" scoped>
</style>